import { get } from 'api';
import { cleanObject } from 'utils/object';

import {
  LOAD_PRODUCTS,
  LOAD_SUBGROUPS,
  PRODUCTS_LOADED,
  RESET_PRODUCTS,
  RESET_SUBGROUPS,
  SUBGROUPS_LOADED,
  SUBGROUPS_SYNC_FAILED,
  SYNC_FAILED,
} from './actionTypes';
import type { IGetProductsParams, IGetSubgroupsParams, ISeedProductsActions } from './types';

export const initialActionsState: ISeedProductsActions = {
  loadProducts: () => {},
  loadSubgroups: () => {},
  resetProducts: () => {},
  resetSubgroups: () => {},
};

export const getActions = (dispatch: {
  (value: { type: any; payload?: any }): void;
  (arg0: { type: string; payload?: any }): void;
}) => ({
  loadProducts: async (params: IGetProductsParams = {}) => {
    dispatch({
      type: LOAD_PRODUCTS,
    });
    const { data, error } = await get('/seed/products', {
      params: cleanObject(params),
    });
    if (data && !error) {
      dispatch({
        type: PRODUCTS_LOADED,
        payload: { data, params },
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  loadSubgroups: async (params: IGetSubgroupsParams = {}) => {
    dispatch({
      type: LOAD_SUBGROUPS,
    });

    const { data, error } = await get('/seed/product-subgroups', { params: cleanObject(params) });

    const formattedData = data
      ? data.map((item) => ({
          ...item,
          treatments: item.treatments.sort(
            (a: any, b: any) =>
              b.isDefault - a.isDefault ||
              a.order - b.order ||
              a.treatmentDescription.localeCompare(b.treatmentDescription),
          ),
        }))
      : null;

    if (formattedData && !error) {
      dispatch({
        type: SUBGROUPS_LOADED,
        payload: formattedData,
      });
    } else {
      dispatch({
        type: SUBGROUPS_SYNC_FAILED,
        payload: error,
      });
    }
  },

  resetProducts: () =>
    dispatch({
      type: RESET_PRODUCTS,
    }),

  resetSubgroups: () =>
    dispatch({
      type: RESET_SUBGROUPS,
    }),
});
